<template>
  <div class="rating">
    <span class="notes">
      <h2 class="sr-only">Note Allociné</h2>
      <wptv-icon
        :specific-alt="''"
        width="22px"
        height="22px"
        name="allocine"
        data-wptv="fip-allocine-icon"
        class="allocine-icon" />
      <span
        v-if="item.allocineRatings.user"
        class="note">
        <span
          aria-hidden="true"
          class="name-note">
          {{ $t('fip.spectateurs') }}
        </span>
        <div class="rating-note">
          <span class="sr-only">
            {{ $t('fip.accessibility.spectateurs', { note: userRating }) }}
          </span>
          <allocine-rating
            :rate="item.allocineRatings.user.rating"
            data-wptv="fip-spectators-rating" />
          <span
            aria-hidden="true"
            class="rating-number">
            {{ userRating }}
          </span>
        </div>
      </span>
      <wptv-icon
        v-if="item.allocineRatings.press && item.allocineRatings.user"
        :specific-alt="''"
        width="22px"
        height="22px"
        name="allocine"
        data-wptv="fip-allocine-icon"
        class="allocine-icon show-from-small" />
      <span
        v-if="item.allocineRatings.press"
        :aria-label="$t('fip.accessibilite_notes_allocine_presse', { rating: $options.filters.convertDotToComma(Math.round(item.allocineRatings.press.rating * 10) / 10) })"
        class="note">
        <span
          aria-hidden="true"
          class="name-note">
          {{ $t('fip.presse') }}
        </span>
        <div class="rating-note">
          <span class="sr-only">
            {{ $t('fip.accessibility.presse', { note: pressRating }) }}
          </span>
          <allocine-rating
            :rate="item.allocineRatings.press.rating"
            data-wptv="fip-press-rating" />
          <span
            aria-hidden="true"
            class="rating-number">
            {{ pressRating }}
          </span>
        </div>
      </span>
    </span>
  </div>
</template>

<script>
import AllocineRating from './allocineRating/AllocineRating'
import { WptvIcon } from '@wptv/components/ui/icon'

export default {
  name: 'Rating',
  components: {
    AllocineRating,
    WptvIcon
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    userRating () {
      return this.$options.filters.convertDotToComma(Math.round(this.item.allocineRatings.user.rating * 10) / 10)
    },
    pressRating () {
      return this.$options.filters.convertDotToComma(Math.round(this.item.allocineRatings.press.rating * 10) / 10)
    }
  }
}
</script>

<style lang="scss" scoped>
.rating {
  display: flex;

  .notes {
    display: flex;
    flex-direction: row;
    align-items: center;

    .allocine-icon {
      margin-right: 10px;
    }

    .note {
      margin-right: 10px;
      display: flex;
      line-height: 20px;
      flex-direction: column;
      @include mediaQueries('flex-direction', (medium: row));
      .rating-number {
        margin-left: 5px;
      }
      .rating-note {
        display: flex;
      }

      &:first-of-type {
        margin-right: 20px;
      }

      .name-note {
        vertical-align: middle;
      }

      .allocine-rating {
        vertical-align: middle;
        @include mediaQueries('margin-left', (medium: 5px));
      }
    }
  }
}
</style>
